import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Popover from 'react-popover'
import { Map } from 'immutable'
import { withTranslation } from 'react-i18next'

import ConfirmOrCancel from 'app/components/Modals/ConfirmOrCancel'
import FeedStoriesListItemMenuPopup from 'app/domains/common/FeedStoriesListItemMenuPopup'
import Dots from 'app/components/SVGS/Dots'

import './styles.scss'
const bc = 'feed-stories-list-item-menu'

const renderMenu = (t, storyId, showModal, toggleMenu, story, question, deleteStory, closeModal) => {
  const initialValues = Map({ story, storyId })
  return (
    <div className={bc}>
      <div
        className={`${bc}__item`}
        onClick={() => {
          showModal(<FeedStoriesListItemMenuPopup question={question} initialValues={initialValues} />)
          toggleMenu()
        }}
      >
        {t('Edit Story')}
      </div>
      <div
        className={`${bc}__item`}
        style={{ color: '#ff8484' }}
        onClick={() => {
          showModal(
            <ConfirmOrCancel
              confirmBtn={t('common:Delete')}
              title={t('Are you sure?')}
              text={t('Once you delete your story, it’s gone forever and you can’t add a new one')}
              handleSubmit={() => {
                deleteStory({ storyId })
                closeModal()
              }}
            />,
            { size: 'xs' }
          )
          toggleMenu()
        }}
      >
        {t('Delete Story')}
      </div>
    </div>
  )
}

const FeedStoriesListItemMenu = ({ t, storyId, showModal, story, question, deleteStory, closeModal }) => {
  const [isOpen, toggleOpen] = useState(false)
  const toggleMenu = () => toggleOpen(!isOpen)
  return (
    <Popover
      isOpen={isOpen}
      preferPlace="below"
      place={null}
      onOuterAction={toggleMenu}
      body={renderMenu(t, storyId, showModal, toggleMenu, story, question, deleteStory, closeModal)}
      tipSize={7}
    >
      <div className={`${bc}__dots`} onClick={toggleMenu}>
        <Dots />
      </div>
    </Popover>
  )
}

FeedStoriesListItemMenu.propTypes = {
  storyId: PropTypes.number.isRequired,
  showModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default withTranslation(['user', 'common'])(FeedStoriesListItemMenu)
